import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import { Checkbox, CheckboxProps } from '@mui/material'

export interface ConditionalTooltipCheckboxProps extends CheckboxProps {
  disabled: boolean
  disableReason: string
}

/**
 * This component provides a possibility to use the common MUI checkbox and show tooltip with reason of disabling if the checkbox is disable
 */
const ConditionalTooltipCheckbox: React.FC<ConditionalTooltipCheckboxProps> = ({ disableReason, disabled, checked, name, onChange, ...props }) =>
  disabled ? (
    <Tooltip title={disableReason}>
      <span>
        <Checkbox {...props} checked={checked} name={name} onChange={onChange} disabled={disabled} />
      </span>
    </Tooltip>
  ) : (
    <Checkbox {...props} checked={checked} name={name} onChange={onChange} />
  )

export default ConditionalTooltipCheckbox
